import { useState, useEffect } from "react";
import { Route, Switch } from "react-router-dom";

import Login from "./components/login/login";
import Header from "./components/header";
import Error from "./components/error";
import Ready from "./components/ready";
import MonitorUserStat from "./components/monitor/monitorUserStat";
import ElderLog from "./components/log/elder/elderLog";

import queryString from "query-string";
import { useLocation } from "react-router";
import { useHistory } from "react-router-dom";
import { authGuest, setToken, isAuthenticated, getToken, isLogin, getUser, setDelToken } from "./service/authService";

import AlertLog from "./components/log/alert/alertLog";
import ManagerMngt from "./components/mngt/manager/managerMngt";
import ElderMngt from "./components/mngt/user/elderMngt";
import AllStatus from "./components/monitor/allStatus/allStatus";
import InstallStatus from "./components/monitor/installStatus/installStatus";
import MonitorDashBoard from "./components/monitor/dashboard/monitorDashboard";
import AlertWindow from "./components/log/alert/alertWindow";
import AccountMngt from "./components/mngt/userInfo/accountMngt";
import DevelopersMonitor from "./components/developersMonitor";
import DeviceCmd from "./components/mngt/device/deviceCmd";
import MainDashboard from "./components/monitor/main/mianDashboard";

function Contents({ codeList, rgnList, dongList, conn, loginStatus, setUpdateLoginStatus, children }) {
  const location = useLocation();

  // if (location.pathname === "/monitor/dashboard") document.body.style.backgroundColor = "#F5F5F5";
  // else document.body.style.backgroundColor = "#FFFFFF";

  document.body.style.backgroundColor = "#F5F5F5";

  const history = useHistory();
  const userInfo = getUser();

  if (location.pathname === "/") history.push("/monitor/status/all");
  // if (location.pathname === "/") history.push("/dashboard");

  useEffect(() => {
    if (userInfo.userTypeCode === 2001 || userInfo.userTypeCode === 2006) {
      alert("권한이 없습니다.");
      setDelToken();
      authGuest(conn).then(result => {
        setToken(result.token);
        setUpdateLoginStatus(false);
      });
    }
  }, [getUser()]);

  return (
    <div id="app">
      <Header conn={conn} loginStatus={loginStatus} setUpdateLoginStatus={setUpdateLoginStatus} />
      <div id="page_content">
        <div id="page_content_inner">
          {children}
          <Switch>
            <Route exact path="/error" render={() => <Error conn={conn} />} />
            <Route exact path="/ready" render={() => <Ready conn={conn} />} />
            <Route exact path="/dashboard" render={() => <MainDashboard conn={conn} />} />
            <Route exact path="/monitor/developer" render={() => <DevelopersMonitor conn={conn} dongList={dongList} />} />
            {/* <Route exact path="/login" render={() => <Login  conn={conn}  setUpdateLoginStatus={setUpdateLoginStatus} loginStatus={loginStatus}/>} /> */}
            <Route
              exact
              path="/monitor/userStat"
              render={() => <MonitorUserStat conn={conn} qs={queryString} codeList={codeList} rgnList={rgnList} dongList={dongList} />}
            />
            {/* 모니터링 */}
            <Route exact path="/monitor/dashboard" render={() => <MonitorDashBoard conn={conn} dongList={dongList} />} />
            <Route exact path="/monitor/status/all" render={() => <AllStatus conn={conn} qs={queryString} rgnList={rgnList} dongList={dongList} />} />
            <Route exact path="/monitor/status/install" render={() => <InstallStatus conn={conn} rgnList={rgnList} dongList={dongList} />}/>

            {/* 이력 */}
            <Route
              exact
              path="/log/elder"
              render={() => <ElderLog conn={conn} qs={queryString} codeList={codeList} rgnList={rgnList} dongList={dongList} />}
            />
            <Route exact path="/log/alert" render={() => <AlertLog conn={conn} dongList={dongList} codeList={codeList} />} />

            {/* 관리 */}
            <Route exact path="/mngt/manager" render={() => <ManagerMngt conn={conn} rgnList={rgnList} dongList={dongList} />} />
            <Route exact path="/mngt/elder" render={() => <ElderMngt conn={conn} rgnList={rgnList} dongList={dongList} />} />
            <Route exact path="/mngt/account" render={() => <AccountMngt conn={conn} />} />
            <Route exact paht="/mngt/device" render={() => <DeviceCmd conn={conn} rgnList={rgnList} dongList={dongList} />} />
          </Switch>
          <AlertWindow conn={conn} />
        </div>
      </div>
    </div>
  );
}

export default Contents;
